<template>
  <vs-prompt
    title='Editar stock'
    :active.sync="isPromptActiveLocal"
    @accept="finishModifyStock()"
    accept-text="Aceptar"
    cancel-text="Cancelar"
  >
    <div class="con-exemple-prompt">
      <div class="w-full" style="position: relative;">
        <h4 class="title">Stock de <b>{{ Product.name }}</b></h4>
        <div class="modifyStockBtnGroup">
          <div class="modifyStockBtn" @click="modifyStock(-1)">
            <font-awesome-icon icon="minus"/>
          </div>
          <div class="stockNum unselectable">
            <input type="number" v-model="newStock">
          </div>
          <div class="modifyStockBtn" @click="modifyStock(+1)">
            <font-awesome-icon icon="plus"/>
          </div>
        </div>
        <!-- modifiedAmount -->
        <div class=" unselectable" style="white-space: nowrap;"
        :class="{modifiedAmountLess: modifiedAmount < 0,  modifiedAmountMore: modifiedAmount > 0, modifiedAmountZero: modifiedAmount == 0}">
          {{ modifiedAmount < 0 ? '-' : '+' }}
          <span>{{ modifiedAmount* (modifiedAmount < 0 ? -1 : 1) }}</span>
        </div>
        <h4 class="text-center mb-1 unselectable">Motivo</h4>
        <vs-select class="reason" v-model="selectedReasonID" color="#15B0CE">
          <vs-select-item :value="Reason.id" :text="Reason.reason" v-for="Reason in Reasons" />
        </vs-select>
        <h4 class="text-center mt-4 mb-1 unselectable">Detalles</h4>
        <vs-input class="notes" v-model="notes"/>
      </div>
    </div>
  </vs-prompt>
</template>




<script>
export default {
  props: {
    Product: Object,
    isPromptActive: Boolean,
  },
  data() {
    return {
      notes: '',
      modifiedAmount: 0,
      selectedReasonID: 0,
      Reasons: [],

      alertMsg: '',
    };
  }, // DATA
  computed: {
    newStock: {
      get() {
        return this.Product.stock + this.modifiedAmount;
      },
      set(newVal, oldVal) {
        this.modifiedAmount = newVal - this.Product.stock;
      }
    },
    isPromptActiveLocalReal: {
      get() {
        return this.isPromptActive;
      },
      set(val) {
        this.isPromptActiveLocal = this.isPromptActiveLocalReal;
      }
    },
    isPromptActiveLocal: {
      get() {
        let value = this.isPromptActiveLocalReal;
        if (value) {
          this.resetData();
        }
        return value;
      },
      set(val) {
        if (val) return;
        this.$emit('closePrompt');
      }
    },
  },
  watch: {
    // modifiedAmount: function(val) {
    //   console.log(val);
    // },
    // selectedReasonID: function(val) {
    //   console.log(val);
    // },
  }, // WATCH
  created() {
    this.loadReasons();
  },
  methods: {
    // checkIsComplete
    // closePrompt
    // finishModifyStock
    // loadReasons
    // modifyStock
    checkIsComplete() {
      // if (this.newStock < 0) {
      //   this.alertMsg = 'El stock no puede ser menor que 0"';
      //   this.closePrompt(true);
      //   return false;
      // }
      // if (this.selectedReasonID == 0) {
      //   this.alertMsg = 'Falta completar el campo "Motivo"';
      //   this.closePrompt(true);
      //   return false;
      // }
      if (this.selectedReasonID == 4) { // "Otros (detallar)"
        if (this.notes == '') {
          this.alertMsg = 'Falta completar el campo "Detalles"';
          this.closePrompt(true);
          return false;
        }
      }
      return true;
    },
    closePrompt(error = false) {
      if (error) {
        this.$emit('restartPrompt', this.alertMsg);
        return;
      }
      this.$emit('closePrompt', { productID: this.Product.id, stock: this.newStock });
    },
    resetData() {
      this.modifiedAmount = 0;
      this.selectedReasonID = 0;
      this.notes = '';
    },
    finishModifyStock() {
      if (this.modifiedAmount == 0) return;
      if (!this.checkIsComplete()) return;
      // Impacta en DB
      let Params = {
        productID:     this.Product.id,
        amount:        this.modifiedAmount,
        reasonID:      this.selectedReasonID,
        websiteZoneID: this.dataDB.StockChangesWebsiteZoneIDs.stockChangePrompt,
        notes:         this.notes,
      }
      this.updateProductStock(Params);
      this.$emit('updateStock', { productID: this.Product.id, newStock: this.newStock });
    }, // finishModifyStock()
    loadReasons() {
      const vm = this;
      this.conectToDB({
        file: 'NewProduct', action: 'getStockChangesReasons', params: {},
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.Reasons = res.data.data;
        },
      });
    },
    modifyStock(change) {
      if (this.newStock == 0 && change == -1) {
        alert('El stock no puede ser menor que 0');
        return;
      }
      this.modifiedAmount += change;
    },
  } // METHODS
}
</script>



<style lang="css" scoped>
  .modifyStockBtnGroup {
    color: #15B0CE;
    border: 1px solid #15B0CE;
    display: inline-block;
    border-radius: 5px;
    overflow: hidden;
    height: 50px;
    text-align: center;
    line-height: 48px;  /* 50 - 2 de borde*/
    display: table;
    margin: 0 auto;
    margin-bottom: 15px;
  }
  .modifyStockBtn {
    width: 50px;
    display: inline-block;
    cursor: pointer;
  }
  .stockNum {
    display: inline-block;
    width: 50px;
    border-left: 1px solid #15B0CE;
    border-right: 1px solid #15B0CE;
  }
  .stockNum input {
    width: 100%;
    border: 0;
    text-align: center;
    height: 47.5px;
    font-size: 17px;
    color: #15B0CE;
    font-weight: bold;
  }
  .modifiedAmountLess {
    background-color: #EA5455;
  }
  .modifiedAmountMore {
    background-color: #28C76F;
  }
  .modifiedAmountZero {
    background-color: #15B0CE;
  }
  .modifiedAmountZero,
  .modifiedAmountLess,
  .modifiedAmountMore {
    font-size: 20px;
    border-radius: 50px;
    height: 50px;
    width: 50px;
    text-align: center;
    padding-top: 9px;
    color: white;
    font-weight: 500;
    top: 0;
    right: 0;
    position: absolute;
  }
  .title {
    text-align: center;
    margin: 0 60px;
    margin-bottom: 15px;
  }
  .notes,
  .reason {
    margin: 0 auto
  }
</style>
